module.exports = __webpack_public_path__ + "img/tilstand_biologiske_kvalitetselement.28435582.jpg";